import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  PageTitleAndSubTitle,
  OverviewCard as OverViewCard,
  Layers,
  SvgTable,
  ToggleGroup,
  BasicTable,
  GroupSelectionCard,
  DiseaseSvg,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import stopLossMessages from '../../core-utils/messages/stopLossTriggers';
import properties from '../../core-utils/properties';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import { Diseases } from '../../core-utils/helper-utils/stopLossTriggerHelpers';
import {
  numFormatterWithSuffix,
  numFormatterWithSuffixForMillion,
  numberToCurrencyFormatter,
} from '../../core-utils/helper-utils/helper';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import {
  STOPLOSS_TRIGGERS,
  STOPLOSS_TRIGGERS_INTERNAL,
} from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import { columns } from './stoplosspageConstants';
import {
  CostValues,
  MemberValues,
  PEPM,
  PMPM,
  formatCostValues,
  formatMemberValues,
  formatPEPM,
  formatPMPM,
  getPepmForCohorts,
  getPepmValueForCohorts,
  getPmpmForCohorts,
  getPmpmValueForCohorts,
} from '../../core-utils/helper-utils/summaryReportHelper';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { getStopLossDiseaseCohortMembers } from '../../core-utils/axios/Cohort/StopLoss';

export const getStoplossSubTitle = () => {
  return (
    <Typography
      fontSize={'14px'}
      lineHeight="177%"
      textColor={patientAccessTheme.palette.text.mediumemphasis}
      fontType="regular"
    >
      Based on stop-loss trigger condition{' '}
      <a
        href="https://drive.google.com/drive/folders/1KxU9pFL2MER7HUiJQcpYYuEHo6MA59Z1?usp=drive_link"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: patientAccessTheme.palette.primary.main,
          textDecoration: 'underline',
        }}
      >
        guidance
      </a>{' '}
      published by the Self-Insurance Institute of America (SIIA); costs shown
      reflect medical claims only.
    </Typography>
  );
};

const StopLossPage = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      marginTop: '40px',
      marginLeft: '63px',
      width: '1182px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
  });
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  //State Variables -
  const [toggleState, setToggleState] = useState<'left' | 'right'>('left');
  const [loading, setLoading] = useState<boolean>(false);
  const [diseaseList, setDiseaseList] = useState<Diseases[]>();
  const memberSummaryStore = useStores().memberSummaryStore;
  const navigate = useNavigate();

  const [diseasesWithMemberIds] = useState<
    { disease: string; memberIds: string[] }[]
  >([]);

  // const [memberIds, setMemberIds] = useState(new Set());
  //Top cards Values:
  const [medicalCost, setMedicalCost] = useState<number>();
  const [rxCost, setRxCost] = useState<number>();
  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });
  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [pmpm, setPmpm] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  const [pepm, setPepm] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [columnId, setColumnId] = useState<string>();

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        stopLossMessages.titleAndSubtitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleDiseaseDropDownList = (data: any) => {
    const localDiseasesDropDownList: string[] = [];
    const localDiseasesMembersMap: Map<string, any> = new Map<string, any>();
    data?.map((diseaseSummaryObject: any) => {
      localDiseasesDropDownList.push(diseaseSummaryObject?.condition);
      localDiseasesMembersMap.set(diseaseSummaryObject?.condition, {
        memberList: diseaseSummaryObject?.memberIds,
        medicalCost: diseaseSummaryObject?.medicalCost,
        rxCost: diseaseSummaryObject?.rxCost,
        pmpm: diseaseSummaryObject?.pmpm,
      });
    });
    memberSummaryStore.setDiseasesDropDownList(localDiseasesDropDownList);
    memberSummaryStore.setDiseasesMembersMap(localDiseasesMembersMap);
  };

  // Edit duration related states and functions
  const employerGroupStore = useStores().employerGroupStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const { loginPageStore, cohortDetailsStore } = useStores();
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getStopLossDiseaseCohortMembers({
        payload,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      }),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
  });

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
    abortController.signal,
  );

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  // useEffects

  const getDiseaseList = async (): Promise<Set<string>> => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.stopLossBaseUrl +
      properties.getDiseaseList;
    const requestBody = {
      ...payload,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };

    const localMemberIds = new Set<string>();

    try {
      const res = await axios.post(baseUrl, requestBody, {
        signal: abortController.signal,
      });

      if (res) {
        setDiseaseList(res.data?.data);
        res.data?.data?.forEach((item: any) => {
          const tempDisease: { disease: string; memberIds: string[] } = {
            disease: '',
            memberIds: [],
          };
          tempDisease.disease = item.condition;
          tempDisease.memberIds = item.memberIds;
          diseasesWithMemberIds.push(tempDisease);
          item.memberIds.forEach((memberId: string) => {
            localMemberIds.add(memberId);
          });
        });
      }
    } catch {
      // handle error
    }

    return localMemberIds;
  };

  const getMembersAndTotalCostAPI = async (resolvedMemberIds: Set<string>) => {
    const baseUrl = properties.aiqBaseUrl + properties.summaryBaseUrl;
    const body = {
      ...payload,
      member_unique_id_list: Array.from(resolvedMemberIds),
      claim_id_list: [],
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res) => {
        if (res.status === 200) {
          setMedicalCost(res.data.data.totalCost[1].totalCost);
          setRxCost(res.data.data.totalCost[0].totalCost);
          setCostValues(formatCostValues(res?.data?.data));
          setMemberValues(formatMemberValues(res?.data?.data));
        }
      })
      .catch(() => {});
  };

  const getPMPMAndPepm = async (resolvedMemberIds: Set<string>) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          member_unique_id_list: Array.from(resolvedMemberIds),
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setPmpm(formatPMPM(res?.data?.data?.pmpm));
          setPepm(formatPEPM(res?.data?.data?.pepm));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  // const loginPageStore = useStores().loginPageStore;
  const recommendedTabStore = useStores().recommendedTabStore;

  const apiCalls = async () => {
    setLoading(true);
    if (!isPlanDatesFetched) {
      setLoading(false);
      return;
    }

    const resolvedMemberIds = await getDiseaseList();

    await Promise.all([
      getMembersAndTotalCostAPI(resolvedMemberIds),
      getPMPMAndPepm(resolvedMemberIds),
      getTotalEligible(),
    ]);

    setLoading(false);
  };

  //data-Preparation:
  // Commented ones are due to AV2-802 - Will be uncommented when implemented
  const getDataForTable = () => {
    const tableDiseaseData: any[] = [];
    diseaseList?.forEach((item) => {
      const row = [];
      //truncate
      row.push(item.condition);
      row.push(numberToCurrencyFormatter(item.totalCost, true, 2));
      row.push(item.currentMembers);
      row.push(item.previousMembers);
      // row.push('Low Risk');
      tableDiseaseData.push(row);
    });
    return tableDiseaseData;
  };
  const getDataForCards = () => {
    const cardData: any[] = [];
    diseaseList?.forEach((item) => {
      const element: any = {
        icon: <DiseaseSvg style={{ width: '24px', height: '24px' }} />,
        width: '374px',
        chipType: 'high-risk',
        labels: ['Total Cost', 'Current members'],
        values: [],
        subTitle: (
          <Typography
            fontSize="14px"
            lineHeight="16.94px"
            fontType="regular"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {'Click on a trigger to view more info'}
          </Typography>
        ),
        isStopLossPage: true,
        memberIds: [],
      };
      //truncate
      element.title = item.condition;
      element.values.push(
        '$' + numFormatterWithSuffixForMillion(item.totalCost, 2),
      );
      element.values.push(item.currentMembers);
      // element.values.push(item.previousMembers);
      element.memberIds = item.memberIds;

      cardData.push(element);
    });
    return cardData;
  };

  const handleBack = () => {
    memberSummaryStore.removeAllData();
    navigate(STOPLOSS_TRIGGERS);
  };

  const hanldeCategoryOnClick = (memberIds: string[], diseaseName: string) => {
    memberSummaryStore.removeAllData();
    handleDiseaseDropDownList(diseaseList);
    memberSummaryStore.setCurrentDisease(diseaseName);

    const pathDetails: any[] = [];
    pathDetails.push([
      'text',
      'Stoploss Triggers',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => {
        handleBack();
      },
    ]);
    pathDetails.push([
      'text',
      stopLossMessages.SUMMARY_FOR + diseaseName,
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ]);
    memberSummaryStore.setDiseasesList(diseasesWithMemberIds);
    memberSummaryStore.setIsStoplossPage(true);
    memberSummaryStore.setMemberIds(memberIds);
    memberSummaryStore.setPathDetails(pathDetails);
    memberSummaryStore.setSummaryLabel(
      stopLossMessages.titleAndSubtitle.title + ' - ' + diseaseName,
    );
    recommendedTabStore?.setCategoryToBeCalled(
      stopLossMessages.SUMMARY_FOR + diseaseName,
    );
    navigate(STOPLOSS_TRIGGERS_INTERNAL, {
      state: {
        categoryToBeCalled: stopLossMessages?.SUMMARY_FOR,
      },
    });
  };

  const getMemberIds = (disease: string) => {
    let ids: string[] = [];

    diseasesWithMemberIds?.map((item) => {
      if (disease === item.disease) {
        ids = item.memberIds;
      }
    });

    return ids;
  };

  const toggleLeftStyles = {
    border: 'none',
    borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
    width: '100px',
  };

  const toggleRightStyles = {
    border: 'none',
    borderLeft: '1px solid ' + patientAccessTheme.palette.grey[300],
    width: '100px',
  };

  const EnrollmentAnalysis = () => {
    return (
      <Box className={classes.flexContainer}>
        <Box className={classes.OverViewCardMargin}>
          <OverviewCardTooltipContent
            type={'member'}
            cohortMemberValues={memberValues}
            totalMemberValues={{
              dependents: overAllEnrolled.dependents,
              employees: overAllEnrolled.employees,
              members: overAllEnrolled.totalCount,
            }}
            overviewCard={
              <OverViewCard
                title={stopLossMessages.cardText.members}
                value={getCohortValue(
                  memberValues.members,
                  overAllEnrolled.totalCount,
                )}
                rootStyles={{
                  width: '215px',
                }}
              />
            }
          />
        </Box>

        <Box className={classes.OverViewCardMargin}>
          <OverviewCardTooltipContent
            type={'cost'}
            cohortCostValues={costValues}
            totalCostValues={{
              medical: overallTotalCost.totalMedical,
              rx: overallTotalCost.totalRx,
              total: overallTotalCost.totalCost,
            }}
            overviewCard={
              <OverViewCard
                title={stopLossMessages.cardText.totalCost}
                value={getCohortValue(
                  '$' + numFormatterWithSuffix(rxCost! + medicalCost!, 2),
                  overallTotalCost.totalCost,
                )}
                rootStyles={{
                  width: '215px',
                }}
              />
            }
          />
        </Box>
        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={stopLossMessages.cardText.pmpm}
            topLabelValues={getPmpmForCohorts(pmpm, [], [])}
            value={getPmpmValueForCohorts(pmpm, [], [])}
            rootStyles={{
              width: '230px',
            }}
          />
        </Box>
        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={stopLossMessages.cardText.pepm}
            topLabelValues={getPepmForCohorts(pepm, [], [])}
            value={getPepmValueForCohorts(pepm, [], [])}
            rootStyles={{
              width: '230px',
            }}
          />
        </Box>
      </Box>
    );
  };

  const CardsComponent = () => {
    return (
      <Box
        style={{
          width: '1203px',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}
      >
        {getDataForCards().map((item, index: number) => {
          return (
            <Box
              key={index}
              style={{
                marginRight: '24px',
                marginBottom: '28px',
                width: '31.25%',
              }}
            >
              <GroupSelectionCard
                // icon={item.icon}
                title={item.title}
                height="210px"
                // chipType={'high-risk'}
                subTitle={item.subTitle}
                labels={item.labels}
                values={item.values}
                isStopLossPage={item.isStopLossPage}
                handleOnClick={() =>
                  hanldeCategoryOnClick(item.memberIds, item.title)
                }
              />
            </Box>
          );
        })}
      </Box>
    );
  };

  const hanldeCategoryOnClickTableView = (disease: any) => {
    const ids = getMemberIds(disease[0]);
    hanldeCategoryOnClick(ids, disease[0]);
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    const newList = diseaseList
      ? [...diseaseList].sort((a: any, b: any) => {
          if (a[sortColumnName] < b[sortColumnName]) {
            return -1 * sortOrder;
          } else if (a[sortColumnName] > b[sortColumnName]) {
            return 1 * sortOrder;
          }
          return 0;
        })
      : [];

    setDiseaseList(newList);
  };

  const TableAndCardView = () => {
    return toggleState === 'left' ? (
      <>
        <CardsComponent />
      </>
    ) : (
      <div
        style={{
          marginBottom: '40px',
        }}
      >
        <BasicTable
          columns={columns}
          rowsData={getDataForTable()}
          isDiseaseTable={true}
          displayType="row"
          width="1182px"
          headerCellHeight={'56px'}
          cellHeight={'56px'}
          handleOnClick={hanldeCategoryOnClickTableView}
          columnId={columnId}
          handleHeaderMouseEnter={(column: any) =>
            handleHeaderMouseEnter(column, setColumnId)
          }
          handleHeaderMouseLeave={() => handleHeaderMouseLeave(setColumnId)}
          showOnHoverHeader={true}
          handleMenuItem={handleSort}
        />
      </div>
    );
  };

  const [loader] = useState<any>(<Loader />);

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <Box className={classes.mainDiv}>
      <Box style={{ width: '1182px' }}>
        <PageTitleAndSubTitle
          title={stopLossMessages.titleAndSubtitle.title}
          subTitle={getStoplossSubTitle()}
          showDownloadButton={true}
          // downloadButtonAction={() => setOpenReportsModal(true)}
          downloadButtonAction={() => {
            downloadPdf(
              'stopLossReport',
              {
                employer:
                  employerGroupStore?.employerGroupResponseData
                    ?.employer_group_name,
                member_unique_id_list: [],
                claim_id_list: [],
                maxClaimDate:
                  employerGroupStore?.employerGroupResponseData?.max_claim_date,
                ...payload,
              },
              handleOpenSnackBar,
              'open',
            );
            handleOpenSnackBar(
              snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
              'info',
              6000,
            );
          }}
          showQueryDataButton={checkUserAccess(
            UserAccessConstants.COHORT_DETAILS,
            loginPageStore.userResponse.role.name,
            loginPageStore.userFeatures,
          )}
          queryButtonText={
            cohortDetailsStore.cohortDetailsList?.length > 0 &&
            cohortDetailsStore.cohortDetailsList[0].category !== ''
              ? 'Edit Cohort'
              : 'Add Cohort'
          }
          queryDataAction={() => {
            if (
              checkUserAccess(
                UserAccessConstants.COHORT_DETAILS,
                loginPageStore.userResponse.role.name,
                loginPageStore.userFeatures,
              )
            ) {
              openModal();
            }
          }}
        />
        <div
          style={{
            position: 'relative',
            top: '-84px',
            left: '152px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize="17px"
            lineHeight="21px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontType="semiBold"
            margin="0px 8px"
          >
            for
          </Typography>
          <DateFilter />
        </div>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleSelectedIndex}
          recommendationFetched={recommendationFetched}
          margin="0px"
        />
        <CohortFilterBar />
      </Box>
      {selectedTabIndex === 0 && (
        <>
          <EnrollmentAnalysis />
          <Box
            style={{
              position: 'relative',
              width: '1176px',
              marginBottom: '24px',
              height: '32px',
            }}
          >
            <Box style={{ position: 'absolute', top: '0', left: '0' }}>
              <Typography
                fontSize="18px"
                fontType="regular"
                lineHeight="26px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {stopLossMessages.viewsHeading.diseases}
              </Typography>
            </Box>

            <Box style={{ position: 'absolute', top: '0', right: '0' }}>
              <ToggleGroup
                leftValue={stopLossMessages.toggleLables.cardView}
                rightValue={stopLossMessages.toggleLables.tableView}
                leftIcon={<Layers style={{ height: '16px', width: '16px' }} />}
                rightIcon={
                  <SvgTable style={{ height: '16px', width: '16px' }} />
                }
                setSelectedToggle={setToggleState}
                toggleLeftSideStyles={toggleLeftStyles}
                toggleRightSideStyles={toggleRightStyles}
              />
            </Box>
          </Box>
          <TableAndCardView />
        </>
      )}
      {selectedTabIndex === 1 && (
        <div style={{ height: '493px', padding: '20px' }}>
          <RecommendationsTab
            recommendationLoading={recommendationLoading}
            isInternalPage={true}
          />
        </div>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={memberIds}
      />

      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </Box>
  );
});

export default StopLossPage;
